/**
 * Configure and mount cookie consent.
 */

const { CookieConsent } = window.kaplanCookieConsent;

const config = {
	text: {
		thirdPartyDescription: 'Consent for the following cookies could not be automatically revoked. Please follow the link(s) below to opt out manually.',
		notifyTitle: 'We use cookies to provide you with better services',
		notifyDescription: 'Please see our <a href="/privacy-notice/">Privacy Notice</a> to learn more.',
	},
	statement: {
		description: 'For more detailed information, see our',
		name: 'Privacy Notice',
		url: '/privacy-notice/',
		updated: '05/09/2022',
	},
};

const consent = new CookieConsent( config );
consent.mount();
